import { Components } from '@mui/material/styles'

export const MuiAlertOverrides: Components['MuiAlert'] = {
  styleOverrides: {
    root: {
      borderRadius: 1, // 8px (1 * 8px)
      padding: '12px 16px', // Mixed values for specific design
    },
  },
}
